/**
 * @file index.tsx
 *
 * @fileoverview Shows a form with an image on the side.
 */

import Picture from "./../../../02-atoms/09-picture";
import React from "react";
import styles from "./formWithImage.module.scss";

export interface FormWithImageProps {
  /**
   * Text for the button
   *
   * @default null
   */
  children?: React.ReactNode;
  /**
   * The image to be displayed next to the form.
   */
  image: string;
  /**
   * Alt title for the image.
   */
  alt: string;
  /**
   * The title for the image.
   */
  title: string;
  /**
   * The optional slot.
   *
   * @default null
   */
  slot?: React.ReactNode;
}

/**
 * Places the form on the center of the page with an image on the side.
 * Useful for login or register pages where what we want the user to do is very clear.
 * It makes the main action and form very clear. Shouldn't be used for very long forms.
 */
export const FormWithImage = ({
  children,
  image,
  alt,
  title,
  slot,
}: FormWithImageProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>{children}</div>
      <div className={styles.right}>
        <Picture landscapeSrc={image} alt={alt} title={title} />
        {slot && <div className={styles.imageSlot}>{slot}</div>}
      </div>
    </div>
  );
};
export default FormWithImage;
